import { render, staticRenderFns } from "./forget-pwd.vue?vue&type=template&id=0cf534ae&scoped=true"
import script from "./forget-pwd.vue?vue&type=script&lang=ts"
export * from "./forget-pwd.vue?vue&type=script&lang=ts"
import style0 from "./forget-pwd.vue?vue&type=style&index=0&id=0cf534ae&prod&lang=scss&scoped=true"
import style1 from "./forget-pwd.vue?vue&type=style&index=1&id=0cf534ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf534ae",
  null
  
)

export default component.exports